export function coerceToString(value) {
    let valueString;
    if ( value === null || value === undefined ) {
        valueString = ''
    } else {
        valueString = value.toString();
    }
    return valueString
}